import { type CurrencyCode } from '@/modules/location/constants';
import { stringToPrice } from '@/modules/price/helpers/stringToPrice';
import {
  type ProductBySlugResponse,
  type ProductBySlugExtendedResponse,
} from '@/modules/product/aliases';

export function getSegmentProductData(
  product: ProductBySlugResponse,
  productExtended: ProductBySlugExtendedResponse
) {
  return {
    product_id: product.id.toString(),
    sku: productExtended.sizes
      ? product.id + '-' + productExtended.sizes[0].id
      : product.id.toString(),
    category: productExtended.attributes.product_type || '',
    name: product.slug,
    brand: productExtended.attributes.brand?.name || '',
    price: stringToPrice(
      productExtended.pricing.discounted_price?.price_breakdown.price.amount ||
        productExtended.pricing.original_price.price_breakdown.price.amount
    ),
    currency: productExtended.pricing.currency as CurrencyCode,
    url: `https://www.depop.com/products/${product.slug}/`,
    quantity: 1,
    google_business_vertical: 'retail',
  };
}
